/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

import GetExternalUserDetailsByID from '@/services/GetExternalUserDetailsByID';
import GetInternalUserDetailsByID from '@/services/GetInternalUserDetailsByID';
import showErrorMessage from '@/util/showErrorMessage';

import GetUsersOTDSData from '../../services/GetUsersOTDSData';

import tmplUserSearchResultView from './UserSearchResultView.hbs';

const UserSearchResultView = View.extend({
  template: tmplUserSearchResultView,

  ui: {
    user: '.user-name'
  },

  events: {
    'click @ui.user': 'selectUser'
  },

  async selectUser(e) {
    let profile, isExternal, groups, edipi;
    try{
      ({ profile, isExternal } = await this.getUserFromDatabase());
      const response = await this.getUserFromOTDS(profile, isExternal);
      groups = response.checkedRoles;
      edipi = response.edipi;
      this.loadUserDetails(profile, groups, edipi)

    } catch (err) {
      showErrorMessage({
        errorCode: err.message.code,
        errorTitle: err.message.string,
        hideAfter: 10,
        errorMessage: err.message.detail      
      });

      this.loadUserDetails(profile, groups, edipi)
    }
  },

  loadUserDetails(profile, groups, edipi) {
    if (profile && groups) {
      Radio.channel('userDetails').trigger('update:profile', profile, groups, edipi);
    } else if (profile && (!groups || !edipi)) {
      Radio.channel('userDetails').trigger('update:profile', profile);
    }
  },

  async getUserFromDatabase() {
    try {
      const userID = this.model.get('id');
      const isExternal = this.model.get('isExternal');
      const profile = (isExternal === '1') ? await GetExternalUserDetailsByID(userID, true) : await GetInternalUserDetailsByID(userID);
      profile.isExternal = this.model.get('isExternal');

      return { profile, isExternal }
    } catch(err) {
      return err;
    }
  },

  async getUserFromOTDS(profile, isExternal) {
    try{
      let response;
      if(profile.otdsUserId) response = await GetUsersOTDSData(profile.otdsUserId, isExternal);

      return response;
    } catch(err) {
      return err;
    }
  }
});

export default UserSearchResultView;